import React, { useEffect, useState } from "react";
import Date_textbox from "./Date_textbox";

export default function Date(props) {
    const {
        controleId,
        comp,
        stateData: data,
        stateErrors: errors,
        codeIsVerified,
        isDisabled,
        handleChange
    } = props;

    const [defaultValue, setDefaultValue] = useState("");

    const handleDateEncryptDecryptedOnChange = (name, valueArray) => {
        // let decValue = "";
        // for (let index = 0; index < valueArray.length; index++) {
        //     const element = valueArray[index];
        //     decValue += element;
        // }
        // let dt = "";
        // if (valueArray.length > 0) {
        //     dt = `${decValue.slice(0, 2)}-${decValue.slice(2, 4)}-${decValue.slice(4)}`;
        // }

        const input = { name: name, value: valueArray };
        handleChange(input);
    };

    return (
        <Date_textbox
            value={data[controleId]}
            label={comp.label}
            isDisabled={isDisabled}
            name={controleId}
            handleOnChange={handleDateEncryptDecryptedOnChange}
            codeIsVerified={codeIsVerified}
            encryptionValidate={comp?.encryptionValidate}
            calenderType={comp?.calenderType}
            visibility={comp?.isVisible}
            errors={errors}
            required={comp?.required}
        />
    );
}